module.exports = __webpack_public_path__ + "assets/GermanyWa.ed196e5b.svg";